const prod = {
    url: {
        //API_URL: 'https://bouhamid.fr:8443/api/v1',
        //API_URL: 'http://193.70.87.148:8080/api/v1',
        //API_URL: 'http://146.59.199.222:8080/api/v1',
        API_URL: 'https://formation.simphoniecils.com/api/v1',
    }
};

const dev = {
    url: {
        API_URL: 'http://localhost:8080/api/v1',
    }
};
export const config = process.env.NODE_ENV === 'development' ?dev: prod;